import { FROM_MOBILE_APP_KEY, getItemSafe } from '../../helpers/localStorage'

function getOrganizationRootURL(
  {
    appProtocol,
    appDomain,
    appPath,
  }: { appProtocol: string; appDomain: string; appPath?: string },
  domain: string
) {
  return new URL(`${appProtocol}${domain}.${appDomain}${appPath ?? ''}`)
}

function getOrganizationPath(
  { appProtocol, appDomain }: { appProtocol: string; appDomain: string },
  domain: string
) {
  return getOrganizationRootURL({ appProtocol, appDomain }, domain).toString()
}

function getOrganizationAppPath(
  {
    appProtocol,
    appPath,
    appDomain,
  }: { appProtocol: string; appPath: string; appDomain: string },
  domain: string
) {
  return getOrganizationRootURL(
    { appProtocol, appDomain, appPath },
    domain
  ).toString()
}

function getAutoSignUrl(
  {
    appPath,
    appDomain,
    apiUrl,
  }: {
    appPath: string
    appDomain: string
    apiUrl: string
  },
  domain: string,
  { apiToken }: { apiToken: string }
) {
  const fromMobileApp = getItemSafe(FROM_MOBILE_APP_KEY)

  if (fromMobileApp === 'true') {
    // Mobile doesn't need cookies
    const mobileURL = getOrganizationRootURL(
      { appProtocol: 'slite://', appDomain },
      domain
    )
    mobileURL.pathname = '/auth/autoSignIn'
    mobileURL.searchParams.append('apiToken', apiToken)
    mobileURL.searchParams.append('returnTo', appPath)
    return mobileURL.toString()
  }

  const regularURL = new URL(
    `${apiUrl}/auth/pre-auto-signin`,
    window.location.origin
  )

  regularURL.searchParams.append('apiToken', apiToken)
  regularURL.searchParams.append('returnTo', appPath)
  regularURL.searchParams.append('organizationDomain', domain)

  return regularURL.toString()
}

function getLoginUrl(
  {
    appProtocol,
    appPath,
    appDomain,
    apiUrl,
  }: {
    appProtocol: string
    appPath: string
    appDomain: string
    apiUrl: string
  },
  {
    organizationId,
    inviteToken,
  }: {
    organizationId?: string
    organizationDomain?: string
    inviteToken?: string
  },
  { forceGoogleLogin = false } = {}
) {
  if (!organizationId) {
    return undefined
  }

  const [organizationDomain] = window.location.hostname.split('.')

  if (forceGoogleLogin) {
    /* Needs this fallback as apiUrl is not always a valid base URL */
    let url
    try {
      url = new URL(`/api/auth/google/login`, apiUrl)
    } catch {
      url = new URL(`/api/auth/google/login`, window.location.origin)
    }
    url.searchParams.append('organizationId', organizationId)
    url.searchParams.append('returnTo', appPath)
    if (inviteToken) {
      url.searchParams.set('userInviteToken', inviteToken)
    }
    return url.toString()
  }

  const url = getOrganizationRootURL(
    { appProtocol, appDomain },
    organizationDomain
  )
  url.pathname = '/auth/login'
  url.searchParams.append('returnTo', appPath)
  if (inviteToken) {
    url.searchParams.set('userInviteToken', inviteToken)
  }
  return url.toString()
}

export const urls = {
  getOrganizationRootURL,
  getOrganizationPath,
  getOrganizationAppPath,
  getAutoSignUrl,
  getLoginUrl,
}
